import { plainToClass } from 'class-transformer'
import Autolinker from 'autolinker'
import Response from '@/utils/response'
import ReportSchedule from '@/models/report-schedule'
import pageLoading from '@/mixins/page-loading'
import pageTitle from '@/mixins/page-title'

export default {
  mixins: [
    pageLoading,
    pageTitle,
  ],
  title () {
    return this.$t("model.report")
  },
  props: {
    repository: Object,
    id: Number
  },
  data () {
    return {
      reportSchedule: new ReportSchedule,
    }
  },
  computed: {
    themeDescription () {
      return Autolinker.link(this.reportSchedule.report_theme.description, {
        urls: { tldMatches: false }
      })
    }
  },
  mounted () {
    this.$store.commit('setBackRoute', {
      name: 'reportTheme-index'
    })
    this.fetchData()
  },
  methods: {
    onAnswer () {
      this.$router.push({
        name: 'report-new',
        params: { report_schedule_id: this.id }
      })
    },
    onEdit () {
      this.$router.push({
        name: 'report-edit',
        params: { id: this.reportSchedule.answered_report.id }
      })
    },
    async fetchData () {
      if (this.loading) return
      this.loading = true
      try {
        const response = new Response(await this.repository.getById(this.id))
        this.reportSchedule = plainToClass(ReportSchedule, response.result)
      } catch (error) {
        this.$store.commit('setAxiosError', error)
      } finally {
        this.loading = false
      }
    }
  }
}
